import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { TOKEN_PATH } from '../constants/voice-call.constants';
import { TokenResponse } from '../models/voice-call.models';

@Injectable({ providedIn: 'root' })
export class VoiceTokenService {
  async fetchToken(sessionId: string, userId: string): Promise<string> {
    const base = environment.pythonUrl.replace(/\/$/, '');
    const url = `${base}${TOKEN_PATH}`;
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': environment.apiKey,
      },
      body: JSON.stringify({ session_id: sessionId, user_id: userId }),
    });

    if (!res.ok) {
      throw new Error(`Token failed: ${res.status}`);
    }

    const data = (await res.json()) as TokenResponse;
    if (!data?.token) {
      throw new Error('Missing token');
    }

    return data.token;
  }
}
